import i18n from "../../../lang/base";
import { FONT } from "../../../value/staticValues";
import { getTimestampToDate, parseLocaleDatetime } from "../../../common/util";

import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { ReactComponent as RedirImg } from '../../../img/ico-prefix-redir.svg';

import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";

import { ListActionMenu, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";

import { PAGE_URL } from "../../../value/Url";
import PodAdd from "./PodAdd";
import PodUpdate from "./PodUpdate";
import { DropdownType } from "../../base/CustomDropdown";
import PodLog from "./PodLog";

export interface PodDetailContainerData {
    pod_container_name: string,
    container_image_name: string,
    container_image_pull_policy: string,
    service_type_code: string|null,
    request_cpu_count: string,
    request_memory_capacity_mb: number,
    limit_cpu_count: string,
    limit_memory_capacity_mb: number,
    use_gpu_yn: boolean,
    commands: string|null,
    volume_mounts: string,
    environments: string,
    ports: string,
    liveness_probe_yn: boolean,
    liveness_probe_commands: string|null,
    liveness_probe_http_get_path: string,
    liveness_probe_http_get_port: number,
    liveness_probe_http_get_headers: string|null,
    liveness_probe_tcp_socket_port: number,
    liveness_probe_init_delay_sec: number,
    liveness_probe_period_sec: number,
    liveness_probe_timeout_sec: number,
    readiness_probe_yn: boolean,
    readiness_probe_commands: string|null,
    readiness_probe_http_get_path: string,
    readiness_probe_http_get_port: number,
    readiness_probe_http_get_headers: string|null,
    readiness_probe_tcp_socket_port: number,
    readiness_probe_init_delay_sec: number,
    readiness_probe_period_sec: number,
    readiness_probe_timeout_sec: number,
    ready_yn: boolean,
    restart_count: number,
    start_yn: boolean,
    state_running_start_date: string|null,
    state_terminate_finish_date: string|null,
    state_terminate_exit_code: string|null,
    state_terminate_reason: string|null,
    state_terminate_message: string|null,
    state_wait_reason: string,
    state_wait_message: string|null
}
export interface PodDetailVolumeData {
    pod_volume_name: string,
    pod_volume_type_code: string,
    claim_name: string|null,
    host_path: string
    host_path_type_code: string;
}
export interface PodDetailData {
    pod_id: string,
    pod_name: string,
    pod_description: string,
    labels: string,
    annotations: string|null,
    container_count: number,
    container_active_count: number,
    volume_count: number,
    node_name: string,
    restart_policy: string,
    initialized_status_yn: boolean,
    initialized_status_reason: string|null,
    initialized_status_message: string|null,
    ready_status_yn: boolean,
    ready_status_reason: string,
    ready_status_message: string|null,
    containers_ready_status_yn: boolean,
    containers_ready_status_reason: string,
    containers_ready_status_message: string,
    pod_scheduled_status_yn: boolean,
    pod_scheduled_status_reason: string|null,
    pod_scheduled_status_message: string|null,
    host_ip_address: string,
    pod_ip_address: string|null,
    pod_message: string|null,
    pod_reason: string|null,
    pod_phase: string,
    pod_yaml: string,
    pod_containers: PodDetailContainerData[],
    pod_volumes: PodDetailVolumeData[],
    create_ts: string,
    update_ts: string,
    pod_profile: string|null,
    namespace: {
        namespace_id: string,
        namespace_name: string
    },
    container_cluster: {
        container_cluster_id: string,
        container_cluster_name: string
    },
    project: {
        project_id: string,
        project_name: string
    },
    deployment: {
        deployment_id: string,
        deployment_name: string,
        create_ts: string,
        update_ts: string
    }
}

export interface PodData {
    pod_id: string,
    pod_name: string,
    pod_description: string,
    labels: string,
    annotations: string|null,
    container_count: number,
    container_active_count: number,
    volume_count: number,
    node_name: string|null,
    restart_policy: string,
    initialized_status_yn: boolean,
    initialized_status_reason: string|null,
    initialized_status_message: string|null,
    ready_status_yn: boolean,
    ready_status_reason: string|null,
    ready_status_message: string|null,
    containers_ready_status_yn: boolean,
    containers_ready_status_reason: string|null,
    containers_ready_status_message: string|null,
    pod_scheduled_status_yn: boolean,
    pod_scheduled_status_reason: string,
    pod_scheduled_status_message: string,
    host_ip_address: string|null,
    pod_ip_address: string|null,
    pod_message: string|null,
    pod_reason: string|null,
    pod_phase: string,
    create_ts: string,
    update_ts: string,
    pod_profile: string|null,
    namespace: {
      namespace_id: string,
      namespace_name: string
    },
    container_cluster: {
      container_cluster_id: string,
      container_cluster_name: string
    },
    project: {
      project_id: string,
      project_name: string
    },
    deployment: {
      deployment_id: string,
      deployment_name: string,
      create_ts: string,
      update_ts: string
    }
}

export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("POD_CREATE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH_WITH_ICON,
            code: "POD_CREATE",
            imgComponent: <AddButtonImg/> ,
            activeImgComponent: <AddButtonActiveImg />,
            inactiveImgComponent: <AddButtonImg style={{filter: "opacity(0.5) grayscale(0.5)"}}/>,
        },
    },
    {
        id: 2,
        name: i18n.t("DELETE_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.CANCEL,
            code: "POD_DELETE",
        },
    },
    {
        id: 3,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "POD_SYNC",
        }
    },
];

export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("NAME_TEXT"),
        accessor: "pod_name",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("BELONG_TO_DEPLOYMENT_TEXT"),
        accessor: "deployment",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value?.deployment_name ? value.deployment_name : "-"}</div>)
    },
    {
        Header: i18n.t("STATUS_TEXT"),
        accessor: "pod_phase",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer}}>{value}</div>)
    },
    {
        Header: i18n.t("POD_SCHEDULED_STATUS_TEXT"),
        accessor: "pod_scheduled_status_yn",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                {
                    value ? "Scheduled" : "No"
                }
            </div>
        )
    },
    {
        Header: i18n.t("POD_INITIALIZED_STATUS_TEXT"),
        accessor: "initialized_status_yn",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                {
                    value ? "Intialized" : "No"
                }
            </div>
        )
    },
    {
        Header: i18n.t("POD_READY_STATUS_TEXT"),
        accessor: "ready_status_yn",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                {
                    value ? "Ready" : "No"
                }
            </div>
        )
    },
    {
        Header: i18n.t("POD_CONTAINERS_READY_STATUS_TEXT"),
        accessor: "containers_ready",
        disableSortBy: true,
        style: {
            width: "100px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{
                display: "flex", alignItems: "center",
                fontFamily: FONT.REGULAR,
                fontSize: 12,
                color: value ? "#3a8344" : "#8c8c8c",
            }}>
                {
                    value.containers_ready_status_yn ? <StatusStableImg style={className.statusImg}/> : <StatusBlockImg style={className.statusImg}/>
                }
                {
                    value.containers_ready_status_yn ? "Ready" : "No"
                }
                {
                    "  (" + value.container_active_count.toString()+ '/' + value.container_count.toString() +")"
                }
            </div>
        )
    },
    {
        Header: i18n.t("CLUSTER_TEXT"),
        accessor: "container_cluster",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.purpleText}}>{value?.container_cluster_name ? value.container_cluster_name: "-"}</div>)
    },
    {
        Header: i18n.t("NAMESPACE_TEXT"),
        accessor: "namespace",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.blueText}}>{value?.namespace_name ? value.namespace_name : "-"}</div>)
    },
    {
        Header: i18n.t("PROJECT_TEXT"),
        accessor: "project",
        disableSortBy: true,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value?.project_name ? value.project_name : "-"}</div>)
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.normalTextContainer}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "110px",
        },
        Cell: ({ cell: {value} }) => (<div style={{...className.normalTextContainer, ...className.dateContainer}}>{value ? parseLocaleDatetime(value) : ""}</div>)
    },
];

export const podAddModalContent = {
    title: i18n.t("CONTAINER_POD_CREATE_TEXT"),
    stepCount: 4,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 1,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 2,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("NEXT_TEXT")
        },
        {
            index: 3,
            prevButtonYn: true,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <PodAdd />,
}

export const podUpdateModalContent = {
    title: i18n.t("CONTAINER_POD_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            deleteButtonYn: true,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <PodUpdate />,
}

export const podLogModalContent = {
    title: i18n.t("POD_LOG_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: false,
            confirmButtonText: i18n.t("CONFIRM_TEXT")
        },
    ],
    innerComponent: <PodLog />,
}
export const probeExecTypes:DropdownType[] = [
    {
        label: "Command",
        value: "CMD"
    },
    {
        label: "HTTP-GET",
        value: "HTTPGET"
    },
    {
        label: "TCP-SOCKET",
        value: "TCPSOCK"
    },
]


const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    statusImg: {
        marginRight: 3
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    greenText: {
        color: "#3a8344"
    },
    blueText: {
        color: "#0853fb"
    },
    purpleText: {
        color: "#7066f1"
    },
}